/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-17 12:44:12
 * @modify date 2023-11-17 12:44:12
 * @desc [description]
 */



import ContentsProps from "interfaceTypes/ContentsProps";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import BackupShareView from "./BackupShareView";
import { PLATFORM_URL } from "value/Url";
import { requests } from "common/RestAPI";
import { BackupShareData, BackupShareExternalData, BackupShareInternalData } from "./BackupShareData";
import BackupResotreDialog from "./BackupShareDialog";
import { PopupModalItemType } from "components/base/modal/PopupModal";
import { POPUP_TYPE } from "value/type";
import { base64Decoding, base64Encoding, checkFormatAllow } from "common/util";
import { DropdownType } from "components/base/CustomDropdown";
import { storageProtocolDropdownItem } from "./BackupData";
import { LOCALSTORAGE, SESSIONSTORAGE } from "value/staticValues";



export default function BackupShareContainer(props:ContentsProps) {
  const { t } = useTranslation();
  const [infoText, setInfoText] = useState('');
  const [infoError, setInfoError] = useState(false);

  const [connectYn, setConnectYn] = useState(false);
  const [internalBackupData, setInternalBackupData] = useState<BackupShareInternalData[]>([]);
  const [externalBackupData, setExternalBackupData] = useState<BackupShareExternalData[]>([]);
  const [selectInternalItems, setSelectInternalItems] = useState<BackupShareInternalData[]>([]);
  const [selectExternalItems, setSelectExternalItems] = useState<BackupShareExternalData[]>([]);
  const [refreshYn, setRefreshYn] = useState(false);

  const [executeImportImageYn, setExecuteImportImageYn] = useState(false);
  const [executeExportImageYn, setExecuteExportImageYn] = useState(false);
  const [executeDeleteExternalImageYn, setExecuteDeleteExternalImageYn] = useState(false);
  
  const [actionResultTitle, setActionResultTitle] = useState("");
  const [actionResultMessage, setActionResultMessage] = useState("");
  const [actionResults, setActionResults] = useState<PopupModalItemType[]>([]);
  const [actionResultCount, setActionResultCount] = useState(0);

  const [storageProtocol, setStorageProtocol] = useState<string>("");
  const [storageIp, setStorageIp] = useState<string>("");
  const [storagePort, setStoragePort] = useState<string>('');
  const [storageAccount, setStorageAccount] = useState<string>('');
  const [storagePassword, setStoragePassword] = useState<string>('');
  const [storagePath, setStoragePath] = useState<string>('');


  const [storageIpWarnYn, setStorageIpWarnYn] = useState(false);
  const [storagePortWarnYn, setStoragePortWarnYn] = useState(false);
  const [storageAccountWarnYn, setStorageAccountWarnYn] = useState(false);
  const [storagePasswordWarnYn, setStoragePasswordWarnYn] = useState(false);
  const [storagePathWarnYn, setStoragePathWarnYn] = useState(false);



  const fetchIdRef = useRef(0);


  useEffect(() => {
    AlertFunction('');
    const protocol = base64Decoding(localStorage.getItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PROTOCOL));
    const ip = base64Decoding(localStorage.getItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_IP));
    const port = base64Decoding(localStorage.getItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PORT));
    const account = base64Decoding(localStorage.getItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_ACCOUNT));
    const password = base64Decoding(localStorage.getItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PASS));
    const path = base64Decoding(localStorage.getItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PATH));

    if(protocol && ip && port && account && password && path) {
      setStorageProtocol(protocol)
      setStorageIp(ip);
      setStoragePort(port);
      setStorageAccount(account);
      setStoragePassword(password);
      setStoragePath(path);
    } else {
      setStorageProtocol("SFTP")
      setStoragePort("22");
      setStorageAccount("root");
    }

  }, []);


  useEffect(() => {
    if(refreshYn && connectYn) {
        executeLoadBackup();
    }
  }, [refreshYn]);


  useEffect(() => {
    if(connectYn) {
      localStorage.setItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PROTOCOL, base64Encoding(storageProtocol));
      localStorage.setItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_IP, base64Encoding(storageIp));
      localStorage.setItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PORT, base64Encoding(storagePort));
      localStorage.setItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_ACCOUNT, base64Encoding(storageAccount));
      localStorage.setItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PASS, base64Encoding(storagePassword));
      localStorage.setItem(LOCALSTORAGE.REMOTE_BACKUP_STORAGE_PATH, base64Encoding(storagePath));
    }
  }, [connectYn]);


  function AlertFunction(text:string, error=false) {
    setInfoText(text);
    setInfoError(error);
  }


  useEffect(() => {
    if(actionResults.length === 0) {
        return ;
    }
    if(actionResultMessage && actionResultTitle) {
        const items = actionResults.map((item, index) => {
            return { target: item.target, successYn: item.successYn, reason: item.reason}
        });
        let completeYn = false;
        if(executeExportImageYn === true) {
          completeYn = items.length === selectInternalItems.length ? true : false;
        } else {
          completeYn = items.length === selectExternalItems.length ? true : false;
        }

        props.showPopupModalCb({
            openYn: true,
            type: POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP,
            title: actionResultTitle,
            message: actionResultMessage,
            items: items,
            completeTargetText: t("VM_BACKUP_IMAGE_NAME"),
            code: "COMPLETE",
            cancelButtonYn: false,
            confirmButtonCb: confirmAction,
            completeYn: completeYn
        });

        if(completeYn) {
            props.setLoading(false);
        }
    }
    if(actionResults.length > 0) {
        setActionResultCount(actionResultCount - 1);
    }
}, [actionResults, actionResultTitle, actionResultMessage]);


useEffect(() => {
  if(actionResultCount > 0) {
      if(executeExportImageYn) {
        if(actionResultCount === selectInternalItems.length) {
            props.setLoading(true);
        }
        setActionResultTitle(t("VM_BACKUP_EXPORT_COMPLETE_TEXT"));
        setActionResultMessage(t("MESSAGE_VM_BACKUP_EXPORT_COMPLETE_MESSAGE"));
        executeExportImage(selectInternalItems[selectInternalItems.length - actionResultCount]);
      } else if(executeImportImageYn) {
        if(actionResultCount === selectExternalItems.length) {
            props.setLoading(true);
        }
        setActionResultTitle(t("VM_BACKUP_IMPORT_COMPLETE_TEXT"));
        setActionResultMessage(t("MESSAGE_VM_BACKUP_IMPORT_COMPLETE_MESSAGE"));
        executeImportImage(selectExternalItems[selectExternalItems.length - actionResultCount]);
      } else if(executeDeleteExternalImageYn) {
        if(actionResultCount === selectExternalItems.length) {
          props.setLoading(true);
      }
      setActionResultTitle(t("VM_BACKUP_DELETE_EXTERNAL_COMPLETE_TEXT"));
      setActionResultMessage(t("MESSAGE_VM_BACKUP_DELETE_EXTERNAL_COMPLETE_MESSAGE"));
      executeDeleteExternalImage(selectExternalItems[selectExternalItems.length - actionResultCount]);
      }
  }
}, [actionResultCount, executeExportImageYn, executeImportImageYn]);

function executeResult(target, successYn, reason:string="") {
  const results = actionResults.concat([{target: target, successYn: successYn, reason:reason }]);
  setActionResults(results);
}

function confirmAction(code) {
  if(code === "BACKUP_EXPORT") {
    setActionResultCount(selectInternalItems.length);
    setExecuteExportImageYn(true);
  } else if(code === "BACKUP_IMPORT") {
    setActionResultCount(selectExternalItems.length);
    setExecuteImportImageYn(true);
  } else if(code === "BACKUP_DELETE") {
    setActionResultCount(selectExternalItems.length);
    setExecuteDeleteExternalImageYn(true);
  } else if(code !== "COMPLETE") {
    if(executeExportImageYn) {
      setActionResultCount(selectInternalItems.length);
    } else {
      setActionResultCount(selectExternalItems.length);
    }
  } else {
      setActionResultCount(0);
      setActionResults([]);
      setActionResultMessage("");
      setActionResultTitle("");
      setExecuteExportImageYn(false);
      setExecuteImportImageYn(false);
      setRefreshYn(true);
      AlertFunction('');
  }
}

function executeImportImage(item) {
  const importPackage = {
    external_backup_storage: {
      storage_protocol: storageProtocol,
      storage_url: storageIp,
      storage_port: Number(storagePort),
      storage_id: storageAccount,
      storage_password: storagePassword,
      storage_path: storagePath
    },
    external_vm_backup_file: {
      vm_backup_filename: item.vm_backup_filename
    },
    vm_backup: {
      vm_backup_name: item.vm_backup_filename.substring(0, item.vm_backup_filename.lastIndexOf('.')),
      vm_backup_description: item.vm_backup_filename + ' from ' + storageIp,
      vm_backup_filename: item.vm_backup_filename
    }
  };
  requests.post(PLATFORM_URL.VM_BACKUP + '/import', importPackage)
  .then((response) => {
      executeResult(item.vm_backup_filename, true);
  })
  .catch((error) => {
      executeResult(item.vm_backup_filename, false);
  })
}

function executeDeleteExternalImage(item) {
  const deletePackage = {
    external_backup_storage: {
      storage_protocol: storageProtocol,
      storage_url: storageIp,
      storage_port: Number(storagePort),
      storage_id: storageAccount,
      storage_password: storagePassword,
      storage_path: storagePath
    },
    external_vm_backup_file: {
      vm_backup_filename: item.vm_backup_filename
    }
  };
  requests.post(PLATFORM_URL.VM_BACKUP + '/external/delete', deletePackage)
  .then((response) => {
    executeResult(item.vm_backup_filename, true);
  })
  .catch((error) => {
      executeResult(item.vm_backup_filename, false);
  })
}

function executeExportImage(item) {
  const exportPackage = {
    external_backup_storage: {
      storage_protocol: storageProtocol,
      storage_url: storageIp,
      storage_port: Number(storagePort),
      storage_id: storageAccount,
      storage_password: storagePassword,
      storage_path: storagePath
    },
    external_vm_backup_file: {
      vm_backup_filename: item.vm_backup_filename
    },
    vm_backup: {
      vm_backup_id: item.vm_backup_id
    }
  };
  requests.post(PLATFORM_URL.VM_BACKUP + '/export', exportPackage)
  .then((response) => {
      executeResult(item.vm_backup_name, true);
  })
  .catch((error) => {
      executeResult(item.vm_backup_name, false);
  })
}

function checkRemoteStorageData() {
  let message = "";
  let error = false;
  let error_count = 0;
  AlertFunction("", false);

  setStorageIpWarnYn(false);
  setStoragePortWarnYn(false);
  setStorageAccountWarnYn(false);
  setStoragePasswordWarnYn(false);
  setStoragePathWarnYn(false);

  if (!storageProtocol) {
    error = true;
    message = t("VM_BACKUP_NEED_BASIC_INFO");
    error_count += 1;
  }
  if (!storagePassword) {
    error = true;
    message = t("VM_BACKUP_ENTER_STORAGE_OS_PASSWORD_MESSAGE");
    setStoragePasswordWarnYn(true);
    error_count += 1;
  }
  if (!storageAccount) {
    error = true;
    message = t("VM_BACKUP_ENTER_STORAGE_OS_ACCOUNT_MESSAGE");
    setStorageAccountWarnYn(true);
    error_count += 1;
  }
  if (!storagePort || checkFormatAllow(storagePort, ["number"]) === false || Number(storagePort) < 1) {
    error = true;
    message = t("VM_BACKUP_ENTER_STORAGE_PORT_MESSAGE");
    setStoragePortWarnYn(true);
    error_count += 1;
  }
  if (!storageIp) {
    error = true;
    message = t("VM_BACKUP_ENTER_STORAGE_URL_MESSAGE");
    setStorageIpWarnYn(true);
    error_count += 1;
  }

  if(error_count > 1) {
    AlertFunction(t("VM_BACKUP_NEED_BASIC_INFO"), false);
  } else {
    AlertFunction(message, false);
  }


  return !error;
}

  function executeLoadBackup() {
    props.setLoading(true);
    const loadPackage = {
      external_backup_storage: {
        storage_protocol: storageProtocol,
        storage_url: storageIp,
        storage_port: Number(storagePort),
        storage_id: storageAccount,
        storage_password: storagePassword,
        storage_path: storagePath
      }
    }
    requests.post(PLATFORM_URL.VM_BACKUP + "/external", loadPackage)
    .then((response) => {
      if (response.status === 200 && response.data) {
        setInternalBackupData(response.data.internal_vm_backups);
        setExternalBackupData(response.data.external_vm_backup_files);
        setConnectYn(true);
        AlertFunction('');
      } else {
        setConnectYn(false);
      }
      setRefreshYn(false);
      props.setLoading(false);
    })
    .catch((error) => {
        props.setLoading(false);
        setConnectYn(false);
        setInternalBackupData([]);
        setExternalBackupData([]);
        if(error.status === 404) {
          AlertFunction(t("MESSAGE_CANNOT_LOAD_BACKUP_DIRECTORY_MESSAGE"), true);
        } else if(error.status === 400) {
          AlertFunction(t("MESSAGE_CANNOT_AUTH_BACKUP_MESSAGE"), true);
        } else {
          AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
        }

        setRefreshYn(false);
    });
  }

  function connectStorage() {
    if(checkRemoteStorageData()) {
      executeLoadBackup();
    }
  }



  function disconnectStorage() {
    setInternalBackupData([]);
    setExternalBackupData([]);
    setConnectYn(false);
  }


  function selectRowIntStorage(items) {
    setSelectInternalItems(items);
  }

  function selectRowExtStorage(items) {
    setSelectExternalItems(items);
  }

  function clickRefresh() {
    if(connectYn === true) {
      connectStorage();
    }
  }

  function clickConnect() {
    if(connectYn === false) {
      connectStorage();
    } else {
      disconnectStorage();
    }
  }
  function clickExport() {
    if(selectInternalItems.length === 0) {
      return;
    }
    props.showPopupModalCb({openYn: true,
                          type: POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP,
                          title: t("MESSAGE_BACKUP_IMAGE_EXPORT_REQUEST_TITLE_MESSAGE"),
                          message: t("MESSAGE_BACKUP_IMAGE_EXPORT_REQUEST_MESSAGE"),
                          items: selectInternalItems.map((item, any, index) => {
                            return {target: item.vm_backup_name}
                          }),
                          code: "BACKUP_EXPORT",
                          cancelButtonYn: true,
                          confirmButtonCb: confirmAction});
  }
  function clickImport() {
    if(selectExternalItems.length === 0) {
      return;
    }
    props.showPopupModalCb({openYn: true,
                          type: POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP,
                          title: t("MESSAGE_BACKUP_IMAGE_IMPORT_REQUEST_TITLE_MESSAGE"),
                          message: t("MESSAGE_BACKUP_IMAGE_IMPORT_REQUEST_MESSAGE"),
                          items: selectExternalItems.map((item, any, index) => {
                            return {target: item.vm_backup_filename}
                          }),
                          code: "BACKUP_IMPORT",
                          cancelButtonYn: true,
                          confirmButtonCb: confirmAction});
  }

  function clickDeleteExternal() {
    if(selectExternalItems.length === 0) {
      return;
    }
    props.showPopupModalCb({openYn: true,
      type: POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP,
      title: t("MESSAGE_BACKUP_IMAGE_DELETE_EXTERNAL_REQUEST_TITLE_MESSAGE"),
      message: t("MESSAGE_BACKUP_IMAGE_DELETE_EXTERNAL_REQUEST_MESSAGE"),
      items: selectExternalItems.map((item, any, index) => {
        return {target: item.vm_backup_filename}
      }),
      code: "BACKUP_DELETE",
      cancelButtonYn: true,
      confirmButtonCb: confirmAction});
  }
  return (
    <View style={{flex: 1}}>
      <BackupShareView
        infoText={infoText}
        infoError={infoError}
        connectCb={clickConnect}
        refreshCb={clickRefresh}
        internalBackupData={internalBackupData}
        externalBackupData={externalBackupData}
        connectYn={connectYn}
        selectRowIntCb={selectRowIntStorage}
        selectRowExtCb={selectRowExtStorage}
        clickExportBtnCb={clickExport}
        clickImportBtnCb={clickImport}
        clickDeleteExternalCb={clickDeleteExternal}
        storageProtocol={storageProtocol}
        setStorageProtocolCb={setStorageProtocol}
        storageIp={storageIp}
        setStorageIpInputCb={setStorageIp}
        storagePort={storagePort}
        setStoragePortCb={setStoragePort}
        storageAccount={storageAccount}
        setStorageAccountCb={setStorageAccount}
        storagePassword={storagePassword}
        setStoragePasswordCb={setStoragePassword}
        storagePath={storagePath}
        setStoragePathCb={setStoragePath}/>
    </View>

  )
}
